import React, { useEffect, useState } from 'react';
import { Row, Col, Tooltip, message, Space } from 'antd';
import ListCard from 'Molecules/ListCard';
import HeadingChip from 'Molecules/HeadingChip';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { getStockTakeList } from '../ducks/actions'
import { removeStockTake, bulkRemoveStockTakes, syncToNetsuite } from '../ducks/services'
import ActionButton from 'Molecules/ActionButton';
import Search from './components/Search';
import AllRoles from '../../../../routing/config/AllRoles';
import { allowed } from '../../../../routing/config/utils';
import dayjs from 'dayjs';
import { getListQueryItems } from 'Modules/Application/ducks/actions';
import { CloseCircleFilled, CheckCircleFilled, CheckCircleTwoTone, CloudSyncOutlined } from '@ant-design/icons';
import { useTranslate } from 'Translate';

export default (props) => {
  const location = useLocation();
  const navigate = useNavigate();
  const queryParameters = new URLSearchParams(location.search);
  const dispatch = useDispatch();
  const orders = useSelector((state) => state.inventory.stockTakes);
  const meta = useSelector((state) => state.inventory.stockTakesOption);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(25);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [searchVal, setSearchVal] = useState(null);
  const allowedEdit = allowed([AllRoles.INVENTORY.STOCK_TAKE], 'write');
  const allowedDelete = allowed([AllRoles.INVENTORY.STOCK_TAKE], 'delete');
  const [outlets, setOutlets] = useState([]);
  const [statuses, setStatuses] = useState([]);
  const globalListQuery = useSelector((state) => state.global.listQueryItems);
  const searchNetsuiteSynced = queryParameters.get('ns') ? queryParameters.get('ns') == "1" : null;
  const searchOutlet = queryParameters.get('ou');
  const searchDate = queryParameters.get('sd');
  const i18n = useTranslate();
    const { t } = i18n;

  const colName = [
    {
      title: t("Inventory.s_take_no"),
      dataIndex: 'reference',
      key: 'reference',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Inventory.s_take_date"),
      dataIndex: 'date',
      key: 'date',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Delete.stock_template"),
      dataIndex: 'stock_template_code',
      key: 'stock_template_code',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Outlet.outlet"),
      dataIndex: 'location_code',
      key: 'location_code',
      className: 'enable-click',
      sorter: true,
      render: (text, record) => <span>{text} {record.location_desc}</span>
    },
    {
      title: t("System.remarks"),
      dataIndex: 'remarks',
      key: 'remarks',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Inventory.created_by"),
      dataIndex: 'created_by_name',
      key: 'created_by_name',
      className: 'enable-click',
      sorter: true
    },
    {
      title: t("Inventory.posting_date_time"),
      dataIndex: 'posted_at',
      key: 'posted_at',
      className: 'enable-click',
      sorter: true,
      render: (text) => <span>{text || "-"}</span>
    },
    {
      title: t("Inventory.is_initial"),
      dataIndex: 'is_initial',
      key: 'is_initial',
      className: 'enable-click',
      align: 'center',
      render: (text) => <span>{text === "1" ? <CheckCircleFilled className='c-success' style={{ fontSize: '20px' }} /> : <CloseCircleFilled className='c-danger' style={{ fontSize: '20px' }} />}</span>
    },
    {
      title: t("General.status"),
      dataIndex: 'status',
      key: 'status',
      sorter: true,
      render: (text, record) =>
        <div className='flex align-items-center'>
          <span className={text === "Posted" ? "c-success" : text === "Pending" ? "c-pending" : "c-danger"}>
            {t(`General.${text?.toLowerCase()}`)}
          </span>
          {" "}
          {
            // allowed([Roles.USERS], 'write') &&
            (text === "Pending" || text === "Posted") &&
            allowedEdit &&
            <Space size={10} >
              {
                (text === "Pending" && record.item_count > 0) &&
                <>
                  {"("}
                    <a className='pointer' onClick={() => onAction(record.id, "post")}>
                      {t("General.post")}
                    </a>
                  {")"}
                </>
              }
              {
                (
                  text === "Posted" &&
                  record?.is_initial === "0" &&
                  record?.can_manual_sync === "1"
                ) &&
                <Tooltip title="Sync to Netsuite">
                  <a className='pointer ml-1' onClick={() => onSyncNetsuite(record.id)}>
                    <CloudSyncOutlined /> {t("General.sync")}
                  </a>
                </Tooltip>
              }
            </Space>
          }
          {record?.item_count > 0 && record?.netsuite_synced_count >= record?.item_count && <Tooltip title={t("Inventory.synced_to_netsuite")}><CheckCircleFilled className="ml-1 c-success" /></Tooltip>}
          {record?.netsuite_synced_count > 0 && record?.netsuite_synced_count < record?.item_count && <Tooltip title="Partially Synced to Netsuite"><CheckCircleTwoTone twoToneColor="#52c41a" className="ml-1" /></Tooltip>}
        </div>
    },
    {
      title: '',
      dataIndex: 'action',
      key: 'action',
      align: 'center',
      render: (text, record) =>
        <ActionButton
          title="stock_take"
          btnAction1={() => navigate(`/inventory/stock-take/${record.id}`)}
          recordId={record.id}
          onRemove={(record?.status === "Pending" && allowedDelete) && onRemove}
          setLoading={props.setLoading}
          loading={props.loading}
        />
    }
  ]

  const addNew = () => navigate('/inventory/stock-take/add');

  const btnList = [
    {
      title: t("Confirm.remove_select_stock_takes"),
      text: t("General.bulk_remove"),
      classes: 'red-btn text-white attendance-success',
      permit: true,
      action: () => onBulkRemove(),
    },
    {
      text: `+ ${t("New.stock_take")}`,
      action: () => addNew(),
    },
  ];

  useEffect(() => {
    if(!globalListQuery.stockTakeListQuery) {
      let search = searchVal || {};
      if (searchNetsuiteSynced !== null) {
        search["netsuite_synced"] = searchNetsuiteSynced ? "1" : "0"
      }
      if (searchOutlet) {
        search["outlet"] = searchOutlet;
      }
      if (searchDate) {
        search["date"] = searchDate;
      }

      setSearchVal(search)
      dispatch(getStockTakeList(1, limit, '', '', search, props.setLoading));
      dispatch(getListQueryItems('stockTakeListQuery', 1, limit, '', '', search, props.setLoading));
    } else {
      const {page, limit, sortOrder, sortColKey, searchValue} = globalListQuery.stockTakeListQuery
      dispatch(getStockTakeList(page, limit, sortOrder, sortColKey, searchValue, props.setLoading));
      setPage(page);
      setLimit(limit);
      setSearchVal(searchValue);
    }
  }, []);

  useEffect(() => {
    if(meta) {
      if('locations' in meta) {
        let temp = [];
        meta?.locations?.map((item, index) => {
          if(index === 0) {
            temp.push({
              label: t("General.all_outlets"),
              value: ""
            })
          }
          temp.push({
            label: `${item.code} ${item.desc}`,
            value: item.id
          })
        });
        setOutlets(temp);
      }

      if ("statuses" in meta) {
        let temp2 = [];
        meta.statuses?.map((x, ind) => {
          if (ind === 0) {
            temp2.push({
              label: t("General.all_status"),
              value: ""
            });
          }
          temp2.push({
            label: x,
            value: x
          })
        });
        setStatuses(temp2);
      }
    }
  }, [meta])

  const onSelectChange = (newSelectedRowKeys) => {
    setSelectedRowKeys(newSelectedRowKeys);
  };

  const rowSelection = {
    selectedRowKeys,
    onChange: onSelectChange,
    getCheckboxProps: (record) => ({
      disabled: record.status !== 'Pending'
    }),
  };

  const onAction = async (sTakeId, status) => {
    props.setLoading(true);

    const payload = {
      stock_take_id: sTakeId,
      status_event: status
    }

    await removeStockTake(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.update_stock_take_status"));
        setTimeout(() => dispatch(getStockTakeList(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('stockTakeListQuery', page, limit, '', '', searchVal, props.setLoading))
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onRemove = async (sTakeId) => {
    props.setLoading(true);

    const payload = {
      stock_take_id: sTakeId,
      status_event: 'remove'
    }

    await removeStockTake(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(t("Success.remove_stock_take"));
        setTimeout(() => dispatch(getStockTakeList(page, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('stockTakeListQuery', page, limit, '', '', searchVal, props.setLoading))
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onBulkRemove = async () => {
    props.setLoading(true);

    const payload = {
      stock_takes: JSON.stringify(selectedRowKeys)
    }

    await bulkRemoveStockTakes(payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        rowSelection.onChange([]);
        message.success(t("Success.remove_stock_takes"));
        setPage(1);
        setSearchVal(null);
        setTimeout(() => dispatch(getStockTakeList(1, limit, '', '', null, props.setLoading)), 500);
        dispatch(getListQueryItems('stockTakeListQuery', 1, limit, '', '', null, props.setLoading))
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  };

  const onSyncNetsuite = async (recordId) => {
    props.setLoading(true);

    const payload = {
      stock_take_id: recordId
    }

    await syncToNetsuite("stock-takes", payload).then(res => {
      props.setLoading(false);
      if (res.data.code === 200) {
        message.success(res.data.message);
        setTimeout(() => dispatch(getStockTakeList(1, limit, '', '', searchVal, props.setLoading)), 500);
        dispatch(getListQueryItems('stockTakeListQuery', 1, limit, '', '', searchVal, props.setLoading))
      } else {
        message.error(res.data.message);
      }
    }).catch(e => {
      props.setLoading(false);
      message.error(e.message ?? t("General.something_went_wrong"));
    })
  }

  const onTableChange = (pagination, filters, sorter) => {
    setPage(pagination.current);
    setLimit(pagination.pageSize);
    if (sorter.order) {
      dispatch(getStockTakeList(pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading));
      dispatch(getListQueryItems('stockTakeListQuery', pagination.current, pagination.pageSize, sorter.order, sorter.columnKey, searchVal, props.setLoading))
    } else {
      dispatch(getStockTakeList(pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading));
      dispatch(getListQueryItems('stockTakeListQuery', pagination.current, pagination.pageSize, '', '', searchVal, props.setLoading))
    }
  }

  const onSearch = (search) => {
    setPage(1);
    navigate('/inventory/stock-take');
    if (search) {
      let searching = {};
      searching = {
        reference: search?.reference,
        status: search.status.value,
        outlet: search?.outlet?.value,
        date: search.date ? dayjs(search.date).format("YYYY-MM-DD") : "",
        netsuite_synced: search?.netsuite_synced?.value
      };
      setSearchVal(searching);
      dispatch(getStockTakeList(1, limit, '', '', searching, props.setLoading));
      dispatch(getListQueryItems('stockTakeListQuery', 1, limit, '', '', searching, props.setLoading))
    } else {
      setSearchVal(null);
      dispatch(getStockTakeList(1, limit, '', '', null, props.setLoading));
      dispatch(getListQueryItems('stockTakeListQuery', 1, limit, '', '', null, props.setLoading))
    }
  };

  const onClickRow = (record) => {
    return {
      onClick: (e) => {
        if (e.target.closest(".enable-click"))
          navigate(`/inventory/stock-take/${record.id}`)
      },
    };
  };

  return (
    <>
      <Row gutter={[10, 10]}>
        <Col span={24}>
          <HeadingChip title={t("General.stock_takes")} btnList={allowedEdit && btnList} btnHidden={selectedRowKeys.length <= 0} />
        </Col>
        <Col span={24} className="clickRow">
          <ListCard
            Search={Search}
            onSearch={onSearch}
            searchVal={globalListQuery.stockTakeListQuery?.searchValue}
            onRow={onClickRow}
            // listClass="nopad"
            ListData={orders?.list?.map(x => ({ ...x, key: x.id }))}
            ListCol={colName}
            rowSelection={allowedEdit && rowSelection}
            onChange={onTableChange}
            pagination={{
              total: orders?.total_count,
              current: page,
              pageSize: limit
            }}
            field1={statuses}
            field2={outlets}
          />
        </Col>
      </Row>
    </>
  )
}